import { Directive, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { DirtyTrackingService } from '../services/dirty-tracking.service';

@Directive({
  selector: 'dirty-tracking',
  standalone: false,
  inputs: ['forms'],
})
export class DirtyTrackingDirective implements OnInit, OnDestroy {
  @Input('forms') forms!: NgForm[];

  private ids: number[];

  private dirtyService = inject(DirtyTrackingService);
  constructor() {

  }

  ngOnDestroy(): void {
    this.dirtyService.clearForms(this.ids);
  }

  ngOnInit(): void {
    this.ids = this.dirtyService.registerForms(this.forms);
  }
}
